import { render } from "./TopSupplier.vue?vue&type=template&id=9aceeb72"
import script from "./TopSupplier.vue?vue&type=script&lang=js"
export * from "./TopSupplier.vue?vue&type=script&lang=js"

import "./TopSupplier.vue?vue&type=style&index=0&id=9aceeb72&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/TopSupplier.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9aceeb72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9aceeb72', __exports__)) {
    api.reload('9aceeb72', __exports__)
  }
  
  module.hot.accept("./TopSupplier.vue?vue&type=template&id=9aceeb72", () => {
    api.rerender('9aceeb72', render)
  })

}


export default __exports__